import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types/news";
import { formatViews } from "@/utils/news";

const rankStyles = [
  "bg-accent-500 text-background-50",
  "bg-accent-400 text-background-50",
  "bg-accent-300 text-accent-950",
];

export default function HotRanking({ list }: { list: NewsArticle[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-600">
          <i className="ri-fire-line text-lg" />
        </span>
        <h3 className="font-heading text-base font-bold text-foreground-950">24小时热门爆料</h3>
      </div>

      <ol className="space-y-1">
        {list.map((item, index) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-label text-xs font-bold ${
                  index < 3 ? rankStyles[index] : "bg-background-200 text-foreground-500"
                }`}
              >
                {index + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="news-clamp-2 block text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line" />
                  {formatViews(item.views)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}